import React, { useState, useEffect } from 'react';
import { collection, getDocs, orderBy, query, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from '../firebaseConfig/firebase';
import { Container, Table, Spinner, Card, InputGroup, Form, Badge, Button, Col, Row } from 'react-bootstrap';
import * as XLSX from 'xlsx';

import Header from './Header';

const DashboardControl = () => {
    const [registros, setRegistros] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const [formSettings, setFormSettings] = useState({ activo: false, update: false, portfoli_activo: false });

    useEffect(() => {
        const fetchData = async () => {
            try {
                // 1. Obtener registros de alumnos
                const q = query(collection(db, "tribu-form"), orderBy("fechaCreacion", "desc"));
                const querySnapshot = await getDocs(q);
                const docs = [];
                querySnapshot.forEach((doc) => {
                    if (doc.id !== "control") {
                        docs.push({ id: doc.id, ...doc.data() });
                    }
                });
                setRegistros(docs);

                // 2. Obtener configuración de control
                const docControlRef = doc(db, "tribu-form-control", "control");
                const docControlSnap = await getDoc(docControlRef);
                if (docControlSnap.exists()) {
                    setFormSettings(docControlSnap.data());
                }
            } catch (error) {
                console.error("Error al obtener datos:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    // Función para cambiar los booleanos de control
    const toggleSetting = async (field) => {
        const newValue = !formSettings[field];
        try {
            const docRef = doc(db, "tribu-form-control", "control");
            await updateDoc(docRef, { [field]: newValue });
            setFormSettings({ ...formSettings, [field]: newValue });
        } catch (error) {
            alert("Error al actualizar la configuración: " + error.message);
        }
    };

    // --- FUNCIÓN PARA BORRAR TODOS LOS REGISTROS ---
    const deleteAllRegistros = async () => {
        const confirmacion = window.confirm(
            "¿Estás seguro de que quieres borrar TODOS los registros? Esta acción no se puede deshacer."
        );

        if (!confirmacion) return;

        setLoading(true);
        try {
            // Obtenemos todos los documentos de la colección
            const querySnapshot = await getDocs(collection(db, "tribu-form"));

            // Usamos un WriteBatch para borrar de forma eficiente
            const { writeBatch } = await import("firebase/firestore"); // Importación dinámica opcional o asegúrate de tenerla arriba
            const batch = writeBatch(db);

            querySnapshot.forEach((doc) => {
                // Evitamos borrar el documento de control si estuviera en la misma colección
                // (Aunque según tu código parece que el control está en 'tribu-form-control')
                batch.delete(doc.ref);
            });

            await batch.commit();

            // Limpiamos el estado local
            setRegistros([]);
            alert("Todos los registros han sido eliminados correctamente.");
        } catch (error) {
            console.error("Error al borrar registros:", error);
            alert("Hubo un error al intentar borrar los datos.");
        } finally {
            setLoading(false);
        }
    };
    // --- FUNCIÓN PARA DESCARGAR EXCEL ---
    const downloadExcel = () => {
        // 1. Mapeamos los datos para que las columnas del Excel tengan nombres bonitos
        const dataToExport = registros.map(reg => ({
            "ALUMNO": reg.ALUMNO,
            "EMAIL_ALUMNO": reg.EMAIL_ALUMNO,
            "PRIORIDAD_1": reg.PRIORIDAD_1,
            "PRIORIDAD_2": reg.PRIORIDAD_2,
            "PRIORIDAD_3": reg.PRIORIDAD_3,
            "PORTFOLIO": reg.PORTFOLIO,
            "PORTFOLI_UPDATE": reg.PORTFOLIO_UPDATE || "Sin actualización",
            "FOUNDATION": reg.FOUNDATION,
            "TELEFONO": reg.TELEFONO,
            "COMENTARIOS": reg.COMENTARIOS,
            "Fecha Registro": reg.fechaCreacion ? new Date(reg.fechaCreacion.seconds * 1000).toLocaleString() : ""
        }));

        // 2. Creamos el libro y la hoja
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Inscripciones");

        // 3. Generamos el archivo y lo descargamos
        XLSX.writeFile(workbook, `Inscripciones_Tribu_${new Date().toLocaleDateString()}.xlsx`);
    };

    const registrosFiltrados = registros.filter(reg =>
        reg.ALUMNO?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        reg.EMAIL_ALUMNO?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) return <div className="text-center mt-5"><Spinner animation="border" /></div>;

    return (
        <>
            <Header />
            <Container className="mt-5 mb-5">
                {/* --- SECCIÓN DE CONTROL DE ESTADO --- */}
                <Card className="mb-4 border-dark shadow-sm">
                    <Card.Body>
                        <Row className="align-items-center text-center">
                            <Col md={2}>
                                <Form.Check
                                    type="switch"
                                    id="activo-switch"
                                    label={formSettings.activo_info ? "🟢 Preinscripción " : "🔴 Preinscripción"}
                                    checked={formSettings.activo_info}
                                    onChange={() => toggleSetting('activo_info')}
                                    className="d-inline-block font-weight-bold"
                                />
                            </Col>
                            <Col md={2}>
                                <Form.Check
                                    type="switch"
                                    id="activo-switch"
                                    label={formSettings.activo ? "🟢 Inscripción" : "🔴 Inscripción"}
                                    checked={formSettings.activo}
                                    onChange={() => toggleSetting('activo')}
                                    className="d-inline-block font-weight-bold"
                                />
                            </Col>
                            <Col md={2}>
                                <Form.Check
                                    type="switch"
                                    id="update-switch"
                                    label={formSettings.portfoli_activo ? "🟢 Portfolio " : "🔴  Portfolio"}
                                    checked={formSettings.portfoli_activo}
                                    onChange={() => toggleSetting('portfoli_activo')}
                                    className="d-inline-block font-weight-bold"
                                />
                            </Col>
                            <Col md={2}>
                                <Form.Check
                                    type="switch"
                                    id="update-switch"
                                    label={formSettings.update ? "🟢 Actualización" : "🔴 Actualización"}
                                    checked={formSettings.update}
                                    onChange={() => toggleSetting('update')}
                                    className="d-inline-block font-weight-bold"
                                />
                            </Col>

                            <Col md={4}>
                                <div className="m-2">
                                    {/* Botón de descarga añadido aquí */}
                                    <Button variant="success" className="me-2" onClick={downloadExcel}>
                                        Exportar Info
                                    </Button>
                                    {/* NUEVO: Botón de borrado masivo */}
                                    <Button variant="danger" onClick={deleteAllRegistros}>
                                        Limpiar
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Card className="shadow">
                    <Card.Header className="bg-dark text-white d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Listado de Inscripciones</h3>
                        <Badge bg="light" text="dark">{registrosFiltrados.length} Registros</Badge>

                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md={10}>
                                <InputGroup className="mb-4 ">
                                    <InputGroup.Text>🔍</InputGroup.Text>
                                    <Form.Control
                                        placeholder="Buscar por nombre o email..."
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />

                                </InputGroup>
                            </Col>

                        </Row>



                        <div className="table-responsive">
                            <Table striped bordered hover>
                                <thead className="table-warning">
                                    <tr>
                                        <th>ALUMNO</th>
                                        <th>EMAIL</th>
                                        <th>PRIORIDADES</th>
                                        <th>PORTFOLIO</th>
                                        <th>TELEFONO</th>
                                        <th>ÚLTIMA MODIFICACIÓN</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {registrosFiltrados.length > 0 ? (
                                        registrosFiltrados.map((reg) => (
                                            <tr key={reg.id}>
                                                <td><strong>{reg.ALUMNO}</strong></td>
                                                <td>{reg.EMAIL_ALUMNO}</td>
                                                <td>
                                                    <small>
                                                        1. {reg.PRIORIDAD_1}<br />
                                                        2. {reg.PRIORIDAD_2}<br />
                                                        3. {reg.PRIORIDAD_3}
                                                    </small>
                                                </td>
                                                <td>
                                                    <a href={reg.PORTFOLIO} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary me-2">
                                                        Original
                                                    </a>
                                                    {reg.PORTFOLIO_UPDATE && (
                                                        <a href={reg.PORTFOLIO_UPDATE} target="_blank" rel="noreferrer" className="btn btn-sm btn-success">
                                                            Nuevo
                                                        </a>
                                                    )}
                                                </td>
                                                <td>{reg.TELEFONO}</td>
                                                <td>
                                                    {reg.fechaUltimaActualizacion
                                                        ? new Date(reg.fechaUltimaActualizacion.seconds * 1000).toLocaleDateString()
                                                        : new Date(reg.fechaCreacion.seconds * 1000).toLocaleDateString()}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center">No se encontraron registros.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        </>
    );
};

export default DashboardControl;